// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.change-box[data-v-4a71afd0] {\n    margin-top: 32px;\n}\n.change-box__form[data-v-4a71afd0] {\n    margin-top: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
